<template>
  <div class="flex flex-col items-stretch absolute right-3 z-10" :class="{'bottom-3': !isMobile, 'mobile-button': isMobile && !extended, 'mobile-button-extended': isMobile && extended}">

    <div v-show="extended" 
          class="flex flex-row justify-end sub-button mb-2" 
          @click="$emit('createSurvey')"
    >
        <div class="sub-label" v-show="extended && canCreateSurvey">
          {{ t(`${organisationPrefix}toolbar.mobile.surveyDetail`) }}
        </div>
        <ion-icon slot="icon-only" 
                  :icon="addOutline" 
                  class="sub-icon"
        />
    </div>
    <div v-show="extended" 
          class="flex flex-row justify-end sub-button mb-2" 
          @click="$emit('createObject')"
    >
        <div class="sub-label" v-show="extended">
          {{ t(`${organisationPrefix}toolbar.mobile.objectDetail`) }}
        </div>
        <ion-icon slot="icon-only" 
                  :icon="addOutline" 
                  class="sub-icon" 
        />
    </div>          
    <ion-icon
      slot="icon-only"
      class="cpb self-end"
      :class="isMobile ? 'cpb-size-mobile' : 'cpb-size'"
      :icon="mainIcon"
      @click="toggleExtended"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { IonIcon } from "@ionic/vue";
import { addOutline, closeOutline } from "ionicons/icons";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  organisationPrefix: {
    type: String,
    default: "",
  },
  canCreateSurvey: {
    type: Boolean,
    default: false,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["createSurvey", "createObject", "extended"]);

const extended = ref(false);
const mainIcon = ref(addOutline);

const toggleExtended = () => {
    extended.value = !extended.value;
    if( extended.value) {
        mainIcon.value = closeOutline;        
    } else {
        mainIcon.value = addOutline;
    }
    emit('extended', extended.value);
};
</script>

<style scoped>

.cpb {
  border-radius: 50%;
  color: white;
  background-color: var(--primary);
}
.cpb-size {
  height: var(--create-button-height);
  width: var(--create-button-height);
}
.cpb-size-mobile {
  height: var(--create-button-height-mobile);
  width: var(--create-button-height-mobile);
}

.sub-button {
  --padding-end: 0.4rem;
  border-radius: 64px;
  cursor: pointer;
  color: var(--primary);
  background: white;
  --background: white;
  height: var(--create-subbutton-height);
  align-items: center;
}

.sub-label {
  padding-right: 0.5rem;
  padding-left: 0.5rem;;
  font-size: 1.2rem;
  font-weight: bold;
  vertical-align: middle;
  color: var(--primary);
}
.sub-icon {
  z-index: 100;
  border-radius: 50%;
  color: white;
  background-color: var(--primary);
  --padding-end: 0.4rem;
  height: var(--create-subbutton-height);
  width: var(--create-subbutton-height);
}
.mobile-button {
  top: calc(var(--create-button-height) * -1 + 1.5rem);
}
.mobile-button-extended {
  top: calc((var(--create-button-height) + var(--create-subbutton-height) * 2) * -1 + 0.6rem);
}
</style>